export default function () {
  // request animation polyfill
  let lastTime = 0;
  let vendors = ['ms', 'moz', 'webkit', 'o'];

  for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
      || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback) {
      let currTime = new Date().getTime();
      let timeToCall = Math.max(0, 16 - (currTime - lastTime));

      let id = window.setTimeout(
        function () {
          callback(currTime + timeToCall);
        },
        timeToCall
      );

      lastTime = currTime + timeToCall;

      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }

  // user agent tests
  this.isMobileDevice = function () {
    return navigator.userAgent.indexOf('Mobile') > -1;
  };

  this.isiPhone = function () {
    return /iPhone|iPod/i.test(navigator.userAgent);
  };

  this.isiPad = function () {
    const userAgent = navigator.userAgent;
    const maxTouchPoints = navigator.maxTouchPoints || 0;
    // Older iPads (iOS 12 and earlier)
    if (/iPad/i.test(userAgent)) {
      return true;
    }

    // Newer iPads (iOS 13 and later)
    if (/Macintosh/i.test(userAgent) && maxTouchPoints > 1) {
      return true;
    }

    return false;
  };

  this.isAndroid = function () {
    return /Android/i.test(navigator.userAgent);
  };

  this.isNoHover = function () {
    return window.matchMedia('(hover: none)').matches;
  };
}
